<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6T4lBN/tc-custom/9780374714994.jpg?1738254612574" alt="This image is the cover for the book Knots"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Knots
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A mesmerizing collection of playfully surreal stories from one of Norway’s most celebrated writers</b><br/><br/>First published in Norway in 2004, <i>Knots </i>is Gunnhild Øyehaug’s radical collection of short stories that range from the surreal to the oddly mundane, and prod the discomforts of mental, sexual, and familial bonds.<br/><br/>In both precise short-shorts and ruminative longer tales, Øyehaug meanders through the tangled, jinxed, and unavoidable conflicts of love and desire. From young Rimbaud’s thwarted passions to the scandalous disappearance of an entire family, these stories do the chilling work of tracing the outlines of what could have been in both the quietly morbid and the delightfully comical. A young man is born with an uncuttable umbilical cord and spends his life physically tethered to his mother; a tipsy uncle makes an uncomfortable toast with unforeseeable repercussions; and a dissatisfied deer yearns to be seen. As one character reflects, “You never know how things might turn out, you never know how anything will turn out, tomorrow the walls might fall down, the room disappear.”<br/><br/>Cleverly balancing the sensuous, the surreal, and the comical, Øyehaug achieves a playful familiarity with the absurd that never overreaches the needs of her stories. Full of characters who can’t help tying knots in themselves and each other, these tales make the world just a little more strange, and introduce a major international voice of searing vision, grace, and humor.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gunnhild Øyehaug
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42bf01d2